import React, { Component } from 'react'
import MUIDataTable from "mui-datatables";
import { IconButton, Button } from '@material-ui/core';
import Launch from '@material-ui/icons/Launch';
import Add from '@material-ui/icons/Add';



export default class CourseTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            isLoaded: false
        }
    }

    onActionClick(el) {
        this.props.actionClick(el);
    }

    onButtonClick = (id) => {
        this.props.onButtonClick(id);
    }


    getStatus(status) {
        if (status === 1) {
            return 'Yes';
        } else {
            return 'No';
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
               
        }
    }

    render() {
        const columns = [
            {
                name: "#",
                options: {
                    filter: true,
                    sort: true,
                }
            },

            {
                name: "Name",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "Balance",
                options: {
                    filter: true,
                    sort: true,
                }
            }
        ];

        const options = {
            filterType: 'checkbox',
            selectableRows: false,
            responsive: 'scroll',
            customToolbar: () => {
                return (
                    <IconButton
                        onClick={this.props.onAddClick}>
                    <Add />
                    </IconButton>
                )
            }
        };

        let data = [];
        let table_data = this.props.table_data;
        
        if (table_data.length > 0) {
            data = table_data.map((el, index) =>
                [index + 1, el.head_name, el.cr_bal]
            )
        } else {
            data = [];
        }

        
        

        return (
            <div>
                <MUIDataTable
                    title={this.props.title}
                    data={data}
                    columns={columns}
                    options={options}

                />
            </div>
        )


    }
}
